import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const DEFAULT_CENTER = [39.5, -98.35];

export default function PropertyMap({ latitude, longitude, onChange }) {
  const nodeRef = useRef(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const initialPositionRef = useRef(
    Number.isFinite(latitude) && Number.isFinite(longitude)
      ? [latitude, longitude]
      : null,
  );

  useEffect(() => {
    if (!nodeRef.current || mapRef.current) return;
    const initialPosition = initialPositionRef.current;
    const map = L.map(nodeRef.current).setView(
      initialPosition || DEFAULT_CENTER,
      initialPosition ? 15 : 4,
    );
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap contributors",
      maxZoom: 19,
    }).addTo(map);
    map.on("click", ({ latlng }) => onChange(latlng.lat, latlng.lng));
    mapRef.current = map;
    return () => {
      map.remove();
      mapRef.current = null;
    };
  }, [onChange]); // Coordinates are synchronized in the effect below.

  useEffect(() => {
    const map = mapRef.current;
    if (!map || !Number.isFinite(latitude) || !Number.isFinite(longitude)) return;
    const position = [latitude, longitude];
    if (!markerRef.current) {
      markerRef.current = L.circleMarker(position, {
        radius: 9,
        color: "#ffffff",
        fillColor: "#648315",
        fillOpacity: 1,
        weight: 3,
      }).addTo(map);
    } else {
      markerRef.current.setLatLng(position);
    }
    map.setView(position, Math.max(map.getZoom(), 13));
  }, [latitude, longitude]);

  return <div ref={nodeRef} style={{ height: 430, width: "100%", borderRadius: 12 }} />;
}
